export const ANNOUNCMENT_CLOSED = 'announcmentClosed';
export const TERMS_CLOSED = 'termsClosed';
